/** @jsx jsx */
/* eslint-disable no-use-before-define */
import {jsx, css} from '@emotion/core'
import {mediaQueries} from './media-queries'

export const Dash = ({margin=15}) => {
    return <div css={dashCss(margin)}>-</div>
}

const dashCss = (margin=15) => css`
    position: absolute;
    width: 100%;
    text-align: center;
    pointer-events: none;
    ${mediaQueries.notXs} {
        bottom: ${margin}px
    }
    ${mediaQueries.xs} {
        bottom: ${margin+5}px
    }
`


// WEBPACK FOOTER //
// ./src/twd/dash.js